// Stellarium Web - Copyright (c) 2019 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>

<v-toolbar dark dense class="obspanel-toolbar">
  <v-btn icon to="/"><v-icon>mdi-close</v-icon></v-btn>
  <v-spacer></v-spacer>
  {{ userFirstName }}
  <v-menu offset-y left v-if="loginEnabled">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>mdi-account-circle</v-icon>
      </v-btn>
    </template>
    <v-list subheader>
      <v-subheader v-if='userLoggedIn'>Logged as {{ userEmail }}</v-subheader>
      <v-list-item v-if='userLoggedIn' to="/p/users/profile">
        <v-list-item-avatar>
          <v-icon>mdi-account-circle</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>My Profile</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if='userLoggedIn' @click="logout()">
        <v-list-item-avatar>
          <v-icon>mdi-exit-to-app</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if='!userLoggedIn' to="/p/users/signin">
        <v-list-item-avatar>
          <v-icon>mdi-account-box</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Sign In</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</v-toolbar>

</template>

<script>
import NoctuaSkyClient from '../../noctuasky-client'

export default {
  data: function () {
    return {
      loginEnabled: true
    }
  },
  methods: {
    logout: function () {
      NoctuaSkyClient.users.logout()
    }
  },
  computed: {
    userLoggedIn: function () {
      return this.$store.state.noctuaSky.status === 'loggedIn'
    },
    userFirstName: function () {
      if (!this.loginEnabled) {
        return ''
      }
      return this.$store.state.noctuaSky.user.first_name ? this.$store.state.noctuaSky.user.first_name : 'Anonymous'
    },
    userEmail: function () {
      return this.$store.state.noctuaSky.user.email
    }
  }
}
</script>

<style>
</style>
